import React, { useRef } from "react";
import { Button } from "react-bootstrap";

const FilePicker = ({ label, onFileSelected, id, variant = "primary", disabled = false, accept = "*",style }) => {
  const inputRef = useRef(null);

  const handleButtonClick = () => {
    inputRef.current.click();
  };

    const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onFileSelected(file);
      e.target.value = ""; // allow re-selecting same file
    }
  };


  return (
    <>
      <Button id={id} variant={variant} disabled={disabled} onClick={handleButtonClick} style={style}>
        {label}
      </Button>
      <input
        type="file"
        accept={accept}
        ref={inputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
};

export default FilePicker;
